import Reflux from 'reflux';

const ClipbardActions = Reflux.createActions(['copy', 'paste']);

export default ClipbardActions;
